// Utilidades de fecha ancladas a la zona horaria de Chile (America/Santiago).
// Respeta automáticamente el cambio de horario de verano/invierno.

// Fecha de hoy en Chile como 'YYYY-MM-DD' (sin desfase UTC).
export function hoyChile() {
  try {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago' }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

// Formatea una fecha DATE ('YYYY-MM-DD' o ISO) como 'DD-MM-YYYY' SIN conversión
// de zona horaria. Para columnas DATE, que representan un día de calendario y no
// deben moverse según la zona del navegador.
export function fechaCL(val) {
  if (!val) return '';
  const s = String(val).slice(0, 10); // YYYY-MM-DD
  const [y, m, d] = s.split('-');
  if (!y || !m || !d) return s;
  return `${d}-${m}-${y}`;
}
